import $ from 'jquery'
import autosize from 'autosize'

export default function()
{
	autosize($('textarea[data-autosize]'))
}



// WEBPACK FOOTER //
// ./public/scripts/src/initializers/autosize.js